import { useEffect, useState } from 'react';
import { authService } from '../../services/api';
import '../../styles/Pagos.css';

const ReportePagosPorCajero = () => {
  const [cajeros, setCajeros] = useState([]);
  const [cajeroSeleccionado, setCajeroSeleccionado] = useState('');
  const [fechaInicio, setFechaInicio] = useState('');
  const [fechaFin, setFechaFin] = useState('');
  const [todasLasFechas, setTodasLasFechas] = useState(false);
  const [reporte, setReporte] = useState(null);
  const [cargando, setCargando] = useState(false);
  const [mensaje, setMensaje] = useState({ tipo: '', texto: '' });

  useEffect(() => {
    cargarCajeros();
    // Establecer fecha de inicio como inicio del mes actual
    const hoy = new Date();
    const primerDia = new Date(hoy.getFullYear(), hoy.getMonth(), 1);
    setFechaInicio(primerDia.toISOString().split('T')[0]);
    setFechaFin(hoy.toISOString().split('T')[0]);
  }, []);

  const cargarCajeros = async () => {
    try {
      // Obtener todos los usuarios (cajeros, cobradores, admin)
      const response = await fetch('/api/permisos/usuarios', {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
      });
      
      if (response.ok) {
        const data = await response.json();
        console.log('Usuarios cargados:', data);
        setCajeros(data.usuarios || data || []);
        
        // Seleccionar usuario actual por defecto
        const currentUser = authService.getCurrentUser();
        if (currentUser) {
          setCajeroSeleccionado(currentUser.id.toString());
        }
      } else {
        console.error('Error al cargar cajeros:', response.status);
        setMensaje({ tipo: 'error', texto: 'Error al cargar lista de cajeros' });
      }
    } catch (error) {
      console.error('Error al cargar cajeros:', error);
      setMensaje({ tipo: 'error', texto: 'Error al cargar lista de cajeros' });
    }
  };

  const cargarReporte = async () => {
    if (!cajeroSeleccionado) {
      setMensaje({ tipo: 'error', texto: 'Debe seleccionar un cajero' });
      return;
    }

    setCargando(true);
    setMensaje({ tipo: '', texto: '' });

    try {
      let url = `/api/pagos/reporte-cajero?cajero_id=${cajeroSeleccionado}`;
      
      // Solo agregar filtros de fecha si no está marcado "Todas las fechas"
      if (!todasLasFechas) {
        if (fechaInicio) {
          url += `&fecha_inicio=${fechaInicio}`;
        }
        
        if (fechaFin) {
          url += `&fecha_fin=${fechaFin}`;
        }
      }

      const response = await fetch(url, {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
      });

      if (response.ok) {
        const data = await response.json();
        setReporte(data);
        setMensaje({ tipo: 'success', texto: `Reporte generado: ${data.resumen.total_pagos} pagos encontrados` });
      } else {
        const error = await response.json();
        setMensaje({ tipo: 'error', texto: error.error || 'Error al generar reporte' });
      }
    } catch (error) {
      console.error('Error al cargar reporte:', error);
      setMensaje({ tipo: 'error', texto: 'Error al cargar el reporte' });
    } finally {
      setCargando(false);
    }
  };

  const formatearMoneda = (valor) => {
    return `$${parseFloat(valor || 0).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`;
  };

  const formatearFecha = (fecha) => {
    if (!fecha) return 'N/A';
    const date = new Date(fecha);
    return date.toLocaleDateString('es-DO', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  const imprimirReporte = () => {
    window.print();
  };

  return (
    <div className="reporte-cajero-container">
      <h2>📊 Reporte de Pagos por Cajero</h2>

      {mensaje.texto && (
        <div className={`mensaje ${mensaje.tipo}`} style={{
          padding: '1rem',
          marginBottom: '1rem',
          borderRadius: '4px',
          backgroundColor: mensaje.tipo === 'success' ? '#d4edda' : '#f8d7da',
          color: mensaje.tipo === 'success' ? '#155724' : '#721c24',
          border: `1px solid ${mensaje.tipo === 'success' ? '#c3e6cb' : '#f5c6cb'}`
        }}>
          {mensaje.texto}
        </div>
      )}

      {/* Filtros */}
      <div className="filtros-section" style={{
        backgroundColor: '#f8f9fa',
        padding: '1.5rem',
        borderRadius: '8px',
        marginBottom: '2rem'
      }}>
        <h3 style={{ marginTop: 0 }}>Filtros</h3>
        
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
          gap: '1rem',
          marginBottom: '1rem'
        }}>
          <div>
            <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: 'bold' }}>
              Cajero / Cobrador:
            </label>
            <select
              value={cajeroSeleccionado}
              onChange={(e) => setCajeroSeleccionado(e.target.value)}
              style={{
                width: '100%',
                padding: '0.5rem',
                borderRadius: '4px',
                border: '1px solid #ddd'
              }}
            >
              <option value="">-- Seleccione un cajero --</option>
              {cajeros.map(cajero => (
                <option key={cajero.id} value={cajero.id}>
                  {cajero.nombre_completo || `${cajero.nombres || ''} ${cajero.apellidos || ''}`} ({cajero.username}) - {cajero.rol}
                </option>
              ))}
            </select>
          </div>

          <div>
            <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: 'bold' }}>
              Fecha Inicio:
            </label>
            <input
              type="date"
              value={fechaInicio}
              onChange={(e) => setFechaInicio(e.target.value)}
              disabled={todasLasFechas}
              style={{
                width: '100%',
                padding: '0.5rem',
                borderRadius: '4px',
                border: '1px solid #ddd',
                backgroundColor: todasLasFechas ? '#f0f0f0' : 'white',
                cursor: todasLasFechas ? 'not-allowed' : 'text'
              }}
            />
          </div>

          <div>
            <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: 'bold' }}>
              Fecha Fin:
            </label>
            <input
              type="date"
              value={fechaFin}
              onChange={(e) => setFechaFin(e.target.value)}
              disabled={todasLasFechas}
              style={{
                width: '100%',
                padding: '0.5rem',
                borderRadius: '4px',
                border: '1px solid #ddd',
                backgroundColor: todasLasFechas ? '#f0f0f0' : 'white',
                cursor: todasLasFechas ? 'not-allowed' : 'text'
              }}
            />
          </div>
        </div>

        {/* Checkbox para todas las fechas */}
        <div style={{ marginBottom: '1rem' }}>
          <label style={{
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem',
            cursor: 'pointer',
            fontSize: '1rem',
            fontWeight: 'bold'
          }}>
            <input
              type="checkbox"
              checked={todasLasFechas}
              onChange={(e) => setTodasLasFechas(e.target.checked)}
              style={{
                width: '18px',
                height: '18px',
                cursor: 'pointer'
              }}
            />
            <span>📅 Mostrar todos los pagos (sin filtro de fechas)</span>
          </label>
        </div>

        <div style={{ display: 'flex', gap: '1rem' }}>
          <button
            onClick={cargarReporte}
            disabled={cargando}
            style={{
              padding: '0.75rem 2rem',
              backgroundColor: '#007bff',
              color: 'white',
              border: 'none',
              borderRadius: '4px',
              cursor: cargando ? 'not-allowed' : 'pointer',
              fontWeight: 'bold',
              opacity: cargando ? 0.6 : 1
            }}
          >
            {cargando ? 'Generando...' : '🔍 Generar Reporte'}
          </button>

          {reporte && (
            <button
              onClick={imprimirReporte}
              style={{
                padding: '0.75rem 2rem',
                backgroundColor: '#28a745',
                color: 'white',
                border: 'none',
                borderRadius: '4px',
                cursor: 'pointer',
                fontWeight: 'bold'
              }}
            >
              🖨️ Imprimir
            </button>
          )}
        </div>
      </div>

      {/* Resumen */}
      {reporte && (
        <>
          <div className="resumen-section" style={{
            backgroundColor: '#e7f3ff',
            padding: '1.5rem',
            borderRadius: '8px',
            marginBottom: '2rem'
          }}>
            <h3 style={{ marginTop: 0 }}>
              📋 Resumen - {reporte.cajero.nombre_completo || `${reporte.cajero.nombres || ''} ${reporte.cajero.apellidos || ''}`}
            </h3>
            
            <div style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
              gap: '1rem',
              marginTop: '1rem'
            }}>
              <div style={{
                backgroundColor: 'white',
                padding: '1rem',
                borderRadius: '4px',
                textAlign: 'center'
              }}>
                <div style={{ fontSize: '0.9rem', color: '#666', marginBottom: '0.5rem' }}>
                  Total Pagos
                </div>
                <div style={{ fontSize: '1.8rem', fontWeight: 'bold', color: '#007bff' }}>
                  {reporte.resumen.total_pagos}
                </div>
              </div>

              <div style={{
                backgroundColor: 'white',
                padding: '1rem',
                borderRadius: '4px',
                textAlign: 'center'
              }}>
                <div style={{ fontSize: '0.9rem', color: '#666', marginBottom: '0.5rem' }}>
                  Préstamos Únicos
                </div>
                <div style={{ fontSize: '1.8rem', fontWeight: 'bold', color: '#17a2b8' }}>
                  {reporte.resumen.total_prestamos}
                </div>
              </div>

              <div style={{
                backgroundColor: 'white',
                padding: '1rem',
                borderRadius: '4px',
                textAlign: 'center'
              }}>
                <div style={{ fontSize: '0.9rem', color: '#666', marginBottom: '0.5rem' }}>
                  Total Capital
                </div>
                <div style={{ fontSize: '1.5rem', fontWeight: 'bold', color: '#28a745' }}>
                  {formatearMoneda(reporte.resumen.total_capital)}
                </div>
              </div>

              <div style={{
                backgroundColor: 'white',
                padding: '1rem',
                borderRadius: '4px',
                textAlign: 'center'
              }}>
                <div style={{ fontSize: '0.9rem', color: '#666', marginBottom: '0.5rem' }}>
                  Total Interés
                </div>
                <div style={{ fontSize: '1.5rem', fontWeight: 'bold', color: '#ffc107' }}>
                  {formatearMoneda(reporte.resumen.total_interes)}
                </div>
              </div>

              <div style={{
                backgroundColor: 'white',
                padding: '1rem',
                borderRadius: '4px',
                textAlign: 'center'
              }}>
                <div style={{ fontSize: '0.9rem', color: '#666', marginBottom: '0.5rem' }}>
                  Total Mora
                </div>
                <div style={{ fontSize: '1.5rem', fontWeight: 'bold', color: '#dc3545' }}>
                  {formatearMoneda(reporte.resumen.total_mora)}
                </div>
              </div>

              <div style={{
                backgroundColor: '#28a745',
                padding: '1rem',
                borderRadius: '4px',
                textAlign: 'center',
                color: 'white'
              }}>
                <div style={{ fontSize: '0.9rem', marginBottom: '0.5rem' }}>
                  💰 TOTAL COBRADO
                </div>
                <div style={{ fontSize: '2rem', fontWeight: 'bold' }}>
                  {formatearMoneda(reporte.resumen.total_cobrado)}
                </div>
              </div>
            </div>
          </div>

          {/* Tabla de Pagos */}
          <div className="tabla-pagos-section">
            <h3>Detalle de Pagos</h3>
            
            <div style={{ overflowX: 'auto' }}>
              <table style={{
                width: '100%',
                borderCollapse: 'collapse',
                backgroundColor: 'white',
                boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
              }}>
                <thead>
                  <tr style={{ backgroundColor: '#007bff', color: 'white' }}>
                    <th style={{ padding: '1rem', textAlign: 'left', borderBottom: '2px solid #0056b3' }}>ID Pago</th>
                    <th style={{ padding: '1rem', textAlign: 'left', borderBottom: '2px solid #0056b3' }}>Fecha</th>
                    <th style={{ padding: '1rem', textAlign: 'left', borderBottom: '2px solid #0056b3' }}>Cliente</th>
                    <th style={{ padding: '1rem', textAlign: 'left', borderBottom: '2px solid #0056b3' }}>Préstamo</th>
                    <th style={{ padding: '1rem', textAlign: 'right', borderBottom: '2px solid #0056b3' }}>Capital</th>
                    <th style={{ padding: '1rem', textAlign: 'right', borderBottom: '2px solid #0056b3' }}>Interés</th>
                    <th style={{ padding: '1rem', textAlign: 'right', borderBottom: '2px solid #0056b3' }}>Mora</th>
                    <th style={{ padding: '1rem', textAlign: 'right', borderBottom: '2px solid #0056b3' }}>Total</th>
                    <th style={{ padding: '1rem', textAlign: 'left', borderBottom: '2px solid #0056b3' }}>Tipo</th>
                  </tr>
                </thead>
                <tbody>
                  {reporte.pagos.map((pago, index) => (
                    <tr
                      key={pago.id}
                      style={{
                        backgroundColor: index % 2 === 0 ? '#f8f9fa' : 'white',
                        borderBottom: '1px solid #dee2e6'
                      }}
                    >
                      <td style={{ padding: '0.75rem' }}>#{pago.id}</td>
                      <td style={{ padding: '0.75rem', fontSize: '0.9rem' }}>
                        {formatearFecha(pago.fecha_pago)}
                      </td>
                      <td style={{ padding: '0.75rem' }}>
                        {pago.cliente.nombres} {pago.cliente.apellidos}
                        <br />
                        <span style={{ fontSize: '0.85rem', color: '#666' }}>
                          {pago.cliente.cedula}
                        </span>
                      </td>
                      <td style={{ padding: '0.75rem' }}>
                        ID: {pago.prestamo.id}
                        <br />
                        <span style={{ fontSize: '0.85rem', color: '#666' }}>
                          {pago.prestamo.tipo} - {pago.prestamo.modalidad}
                        </span>
                      </td>
                      <td style={{ padding: '0.75rem', textAlign: 'right', color: '#28a745' }}>
                        {formatearMoneda(pago.monto_capital)}
                      </td>
                      <td style={{ padding: '0.75rem', textAlign: 'right', color: '#ffc107' }}>
                        {formatearMoneda(pago.monto_interes)}
                      </td>
                      <td style={{ padding: '0.75rem', textAlign: 'right', color: '#dc3545' }}>
                        {formatearMoneda(pago.monto_mora)}
                      </td>
                      <td style={{ padding: '0.75rem', textAlign: 'right', fontWeight: 'bold' }}>
                        {formatearMoneda(pago.monto_total)}
                      </td>
                      <td style={{ padding: '0.75rem' }}>
                        <span style={{
                          padding: '0.25rem 0.5rem',
                          borderRadius: '4px',
                          fontSize: '0.8rem',
                          backgroundColor: pago.tipo_pago === 'normal' ? '#d4edda' :
                                          pago.tipo_pago === 'extraordinario' ? '#fff3cd' :
                                          '#d1ecf1',
                          color: pago.tipo_pago === 'normal' ? '#155724' :
                                 pago.tipo_pago === 'extraordinario' ? '#856404' :
                                 '#0c5460'
                        }}>
                          {pago.tipo_pago}
                        </span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </>
      )}

      {!reporte && !cargando && (
        <div style={{
          textAlign: 'center',
          padding: '3rem',
          color: '#666'
        }}>
          <p style={{ fontSize: '1.2rem' }}>
            Seleccione un cajero y haga clic en "Generar Reporte" para ver los resultados
          </p>
        </div>
      )}
    </div>
  );
};

export default ReportePagosPorCajero;

